export default "__VITE_ASSET__ChkBeRh0__"